import { render } from "./lonjaDetail.vue?vue&type=template&id=d7c5d152&scoped=true"
import script from "./lonjaDetail.vue?vue&type=script&lang=js"
export * from "./lonjaDetail.vue?vue&type=script&lang=js"

import "./lonjaDetail.vue?vue&type=style&index=0&id=d7c5d152&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7c5d152"]])

export default __exports__